//Site wide Search

export const SITE_WIDE_SEARCH = "SITE_WIDE_SEARCH";
export const SITE_WIDE_SEARCH_SUCCESS = "SITE_WIDE_SEARCH_SUCCESS";
export const SITE_WIDE_SEARCH_FAILURE = "SITE_WIDE_SEARCH_FAILURE";
